/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Age_Gt2yInputs */

const en_us2_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than 2 years ago`)
};

const pt_br2_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há mais de 2 anos`)
};

const es_419_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace más de 2 años`)
};

const pt_pt2_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há mais de 2 anos`)
};

const fr_fr2_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a plus de 2 ans`)
};

const de_de2_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor mehr als 2 Jahren`)
};

const it_it2_bodymap_age_gt2y = /** @type {(inputs: Bodymap_Age_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più di 2 anni fa`)
};

/**
* | output |
* | --- |
* | "More than 2 years ago" |
*
* @param {Bodymap_Age_Gt2yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_age_gt2y = /** @type {((inputs?: Bodymap_Age_Gt2yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Age_Gt2yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_age_gt2y(inputs)
	if (locale === "es-419") return es_419_bodymap_age_gt2y(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_age_gt2y(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_age_gt2y(inputs)
	if (locale === "de-DE") return de_de2_bodymap_age_gt2y(inputs)
	if (locale === "it-IT") return it_it2_bodymap_age_gt2y(inputs)
	return en_us2_bodymap_age_gt2y(inputs)
});
export { bodymap_age_gt2y as "bodymap.age.gt2y" }